<template>
  <v-dialog v-model="dialog" fullscreen scrollable>
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        @click="editScript"
        v-on="on"
        :text="!hideTitle"
        :icon="hideTitle"
        :title="name"
      >
        <v-icon v-text="eventIcon"></v-icon>
        <span v-if="!hideTitle">{{ name }}</span>
      </v-btn>
      <v-btn
        v-if="value"
        icon
        color="error"
        @click="clearScript"
        title="Remove Script"
      >
        <v-icon>mdi-close-circle</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span>Script Editor</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <WorkflowDesigner
          :value="actions"
          :types="types"
          @action-select="actionSelect"
        >
          <component
            v-if="selectedAction"
            :is="selectedAction.actionType + 'Designer'"
            v-model="selectedAction"
            :table="table"
            :component="component"
            :containers="containers"
          />
        </WorkflowDesigner>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="save"> OK </v-btn>
        <v-btn text color="error" @click="cancel"> Cancel </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkflowDesigner from "../../workflow/designer/WorkflowDesigner.vue";
import action_types from "./action_types.js";
import action_designers from "./action_designers.js";

export default {
  name: "ScriptEditor",

  components: { WorkflowDesigner, ...action_designers },

  props: [
    "name",
    "icon",
    "value",
    "json",
    "table",
    "component",
    "containers",
    "hideTitle",
  ],

  data() {
    return {
      dialog: false,
      actions: [],
      selectedAction: null,
    };
  },

  computed: {
    eventIcon() {
      return this.icon == null ? "mdi-cursor-default-click-outline" : this.icon;
    },
    types() {
      return action_types;
    },
  },

  methods: {
    editScript() {
      if (this.value) {
        if (this.json) {
          this.actions = JSON.parse(this.value);
        } else {
          this.actions = JSON.parse(JSON.stringify(this.value));
        }
      } else {
        this.actions = [];
      }

      this.dialog = true;
    },
    clearScript() {
      this.$emit("input", null);
    },
    actionSelect({ selection }) {
      this.selectedAction = selection;
    },
    save() {
      if (this.json) {
        this.$emit("input", JSON.stringify(this.actions));
      } else {
        this.$emit("input", JSON.parse(JSON.stringify(this.actions)));
      }
      this.dialog = false;
    },
    cancel() {
      this.selectedAction = null;
      this.dialog = false;
    },
  },
};
</script>
